import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlayCircle, FiSparkles, FiMic, FiFilm, FiPenTool, FiShare, FiLayers, FiBriefcase, FiTerminal } = FiIcons;

const features = [
  { icon: FiPlayCircle, color: 'text-brand-electric', bgColor: 'bg-brand-electric/20', title: 'Any video, any platform', body: 'YouTube, Vimeo, Zoom recordings, webinars, podcasts. If it has audio, VidRevive can transform it.' },
  { icon: FiSparkles, color: 'text-brand-neon', bgColor: 'bg-brand-neon/20', title: 'Smart educational structure', body: 'Content is reorganized into proper modules: learning objectives, concept slides, key takeaways. Not just transcript chunks.' },
  { icon: FiMic, color: 'text-brand-mint', bgColor: 'bg-brand-mint/20', title: 'Your voice, every time', body: 'Upload a 5-minute sample. VidRevive clones your voice using ElevenLabs technology. Every slide sounds like you — not a robot.' },
  { icon: FiFilm, color: 'text-brand-electric', bgColor: 'bg-brand-electric/20', title: 'Bring slides to life', body: 'Static slides become animated explainer videos with smooth motion effects. Powered by fal.ai — the most advanced AI video generation engine.', badge: 'NEW' },
  { icon: FiPenTool, color: 'text-brand-neon', bgColor: 'bg-brand-neon/20', title: 'Your brand, every time', body: 'Upload your logo, set your colors and fonts once. Every transformation automatically matches your visual identity.' },
  { icon: FiShare, color: 'text-brand-mint', bgColor: 'bg-brand-mint/20', title: 'Multi-Format Export', body: 'Download as branded MP4 video, PPTX presentation, PDF handout, or publish to your LMS. One transformation, all formats.' },
  { icon: FiLayers, color: 'text-brand-electric', bgColor: 'bg-brand-electric/20', title: 'Batch Processing', body: 'Transform 50 videos at once. Queue your entire YouTube channel or video library. VidRevive processes everything overnight.' },
  { icon: FiBriefcase, color: 'text-brand-neon', bgColor: 'bg-brand-neon/20', title: 'White-Label', body: 'Deploy a fully white-labeled instance on your subdomain. Perfect for training companies and agencies serving multiple clients.' },
  { icon: FiTerminal, color: 'text-brand-mint', bgColor: 'bg-brand-mint/20', title: 'API Access', body: 'REST API for LMS integration with TalentLMS, Docebo, Moodle, or any custom platform. Full webhook support.' },
];

const FeaturesGrid = () => {
  return (
    <section className="py-28 relative bg-gradient-to-b from-brand-dark via-brand-card/20 to-brand-dark border-t border-white/5">
      {/* Decorative separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-mint/50 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <FadeIn key={idx} delay={idx * 0.1}>
              <div className="glass-card p-6 md:p-8 h-full transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl hover:shadow-brand-electric/20 group border border-white/10 hover:border-brand-electric/40">
                
                <div className="flex justify-between items-start mb-6">
                  <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${feature.bgColor} border border-white/20 flex items-center justify-center shadow-lg`}>
                    <SafeIcon icon={feature.icon} className={`text-xl md:text-2xl ${feature.color}`} />
                  </div>
                  {feature.badge && (
                    <span className="px-2 md:px-3 py-1 md:py-1.5 text-[10px] md:text-xs font-black rounded-full bg-emerald-500/20 text-emerald-400 border border-emerald-500/40 uppercase tracking-wider">
                      {feature.badge}
                    </span>
                  )}
                </div>

                <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4">{feature.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{feature.body}</p>
              </div>
            </FadeIn>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesGrid;